module.exports = __webpack_public_path__ + "media/reju6.0936e5df.mp4";